import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { observeElementRect as t } from "@radix-ui/rect";
import * as r from "react";
export function useRect(e) {
  var _r$useState = r.useState(),
      _r$useState2 = _slicedToArray(_r$useState, 2),
      o = _r$useState2[0],
      c = _r$useState2[1];

  return r.useEffect(function () {
    if (e) {
      var _r = t(e, c);

      return function () {
        c(void 0), _r();
      };
    }
  }, [e]), o;
}